import { Component, HostBinding, Input } from '@angular/core';
import {
  DeclarativeForm,
  FieldsetDeclaration,
} from '@fmnts/declarative-forms/core';

@Component({
  selector: 'declarative-fieldset',
  templateUrl: './declarative-fieldset.component.html',
  standalone: false,
})
export class DeclarativeFieldsetComponent {
  @Input({ required: true }) fieldset!: FieldsetDeclaration;
  @Input({ required: true }) form!: DeclarativeForm;

  @HostBinding('class.form-fieldset--hidden')
  public get isHidden(): boolean {
    return this.form.get(this.fieldset.key)?.disabled || false;
  }

  @HostBinding('class') get key(): string {
    return `fieldset-key--${this.fieldset.key}`;
  }
}
